import React, { useState, useEffect } from 'react';
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import ELVSection from '../ELVSection/ELVSection';
import BenefitsSection from '../BenefitsSection/BenefitsSection';
import ScrappingSection from '../ScrappingSection/ScrappingSection';
import ReturnsSection from '../ReturnsSection/ReturnsSection';
import Faq from '../Faq/Faq';
import './RvsfMain.scss';
import Carousel from '../Carousel/Carousel';
import CustomerEnquiryBanner from '../CustomerEnquiryBanner/CustomerEnquiryBanner';

const RvsfMain = (props) => {
  return (
    <div>
      <Carousel {...props.sitecoreData} />
      <ELVSection {...props.sitecoreData} />
      <BenefitsSection benefitData={props.sitecoreData.fields} />
      <ScrappingSection scrappingData={props.sitecoreData.fields} />
      <ReturnsSection returnSectionData={props.sitecoreData.fields} />
      <Faq faqData={props.sitecoreData.fields} />
      <CustomerEnquiryBanner {...props.sitecoreData} />
    </div>
  );
};

export default withSitecoreContext()(RvsfMain);
